import { z } from 'zod';

/**
 * `GET /messaging/templates/for-workflows` → `data[]`: template WhatsApp
 * approvati (con `content_sid`) proposti dai nodi workflow "invia template".
 * `variables` è la colonna jsonb così com'è salvata (array di placeholder).
 */
export const messagingWorkflowTemplateOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  content_sid: z.string(),
  body_text: z.string().nullable(),
  category: z.string().nullable(),
  variables: z.array(z.unknown()).nullable(),
});
export type MessagingWorkflowTemplateOption = z.infer<typeof messagingWorkflowTemplateOptionSchema>;
